import styled from '@emotion/styled';

import Card from 'components/global/Card';

import { Breakpoints } from 'utils/const.styles';

export const ModuleDetail = styled(Card)`
	overflow: hidden;
	display: flex;
	flex-direction: column;
	padding: 0 !important;
`;

export const Header = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid var(--border-color);
	padding: 2.4rem;
`;

export const ModuleInfo = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1.6rem;
`;

export const ModuleActions = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1.6rem;

	@media ${Breakpoints.mobile} {
		.button > .button-text {
			display: none;
		}
	}
`;

export const ModuleTitle = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: space-between;
	gap: 0.8rem;
`;

export const Line = styled.span`
	height: 1px;
	min-height: 1px;
	background-color: var(--border-color);
	width: 100%;

	display: block;

	@media ${Breakpoints.mobile} {
		margin: 2.4rem auto;
	}
`;

export const Content = styled.div`
	overflow-y: auto;
	height: 100%;
	min-height: 0;
	flex: 1;

	.swiper {
		width: 100%;
		height: 100%;
		margin-left: auto;
		margin-right: auto;
		position: relative;
	}
`;

export const ContentContainer = styled.div`
	padding: 6.4rem;
	display: flex;
	flex-direction: column;
	gap: 6.4rem;

	@media ${Breakpoints.mobile} {
		padding: 2.4rem;
	}
`;

export const Hero = styled.div`
	display: grid;
	grid-template-columns: 1fr 40rem;
	gap: 4.8rem;
	width: 100%;

	@media ${Breakpoints.mobile} {
		grid-template-columns: 1fr;
	}
`;

export const HeroLeft = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
`;

export const HeroContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 2.4rem;
`;

export const HeroSupport = styled(Card)`
	background-color: var(--background-1) !important;
	padding: 2.4rem;
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
`;

export const SupportItem = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	gap: 1.6rem;

	> .button {
		padding: 0;
		> .typography {
			text-decoration: underline;
		}
	}
`;

export const AvailablePlan = styled.div`
	display: flex;
	align-items: center;
	gap: 0.8rem;
`;

export const Features = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 3.2rem;

	.swiper-wrapper {
		width: 100%;
		padding-bottom: 6rem;
	}

	.swiper-slide {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
`;

export const DesktopSlider = styled.div`
	display: block;
	width: 100%;
	@media ${Breakpoints.mobile} {
		display: none;
	}
`;

export const MobileSlider = styled.div`
	display: none;

	@media ${Breakpoints.mobile} {
		display: block;
	}
`;

export const FeatureRow = styled.div`
	display: flex;
	gap: 20px;
	margin-bottom: 20px;
	width: 100%;
	justify-content: center;

	&.feature-top-row {
		display: grid;
		grid-template-columns: ${(props) => (props.size < 3 ? '1fr 1fr' : '1fr 1fr 1fr')};
	}
	&.feature-bottom-row {
		display: grid;
		grid-template-columns: 1fr 1fr;
	}
`;

export const Feature = styled(Card)`
	background-color: var(--background-1) !important;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: space-between;
	gap: 3.2rem;
	padding: 2.4rem;
	min-height: 26.1rem;
	border-radius: 0.8rem;
	flex: 1;
`;

export const FeatureContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.6rem;
	width: 100%;
`;
export const Guide = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4rem;
	width: 100%;
`;

export const GuideList = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 2.4rem;
	@media ${Breakpoints.mobile} {
		display: flex;
		flex-direction: column;
		gap: 2.4rem;
	}
`;

export const GuideContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
`;

export const GuideItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;

	img {
		cursor: pointer;
	}
`;

export const GuideButton = styled.button`
	background-color: transparent;
	border: none;
	text-align: left;
	padding: 1rem 1rem 1rem 4rem;
	border-left: 3px solid ${(props) => (props.isActive ? 'var(--blue)' : 'var(--border-color)')};
	cursor: pointer;
	transition: all 0.3s ease;
	display: flex;
	gap: 1rem;

	body[dir='rtl'] & {
		border-left: none;
		border-right: 3px solid ${(props) => (props.isActive ? 'var(--blue)' : 'var(--border-color)')};
		padding: 1rem 4rem 1rem 1rem;
		text-align: right;
	}
`;

export const GuideText = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	.description {
		li {
			margin-bottom: 1.5rem;
		}
	}
`;

export const Testimonials = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 2.4rem;
	margin-bottom: 4rem;
`;

export const TestimonialsContent = styled.div`
	width: 100%;
	position: relative;
	.swiper-wrapper {
		padding-bottom: 6rem;
	}
	.swiper-slide {
		height: auto !important;
		display: flex;
	}
`;

export const TestimonialsItem = styled(Card)`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: space-between;
	gap: 2.4rem;
	flex: 1;
	padding: 3.2rem;
	background-color: var(--background-1) !important;
`;

export const TestimonialsAuthor = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1.6rem;
`;

export const FAQs = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 2.4rem;
`;

export const FAQsContent = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
`;

export const RelatedModules = styled.div`
	width: 100%;
`;

export const RelatedModulesList = styled.div`
	margin-top: 2.4rem;
	.swiper-slide {
		height: auto !important;
		display: flex;
	}

	@media ${Breakpoints.mobile} {
		.swiper-wrapper {
			padding-bottom: 6rem;
		}
	}
`;

export const MobileGallery = styled.div`
	display: none;
	@media ${Breakpoints.mobile} {
		display: block;
		.swiper {
			background: var(--background-1);
			width: 100%;
			height: 100%;
		}

		.swiper-wrapper {
			height: auto !important;
			padding-bottom: 8rem;
		}

		.swiper-slide {
			width: 100% !important;
			height: 100%;
		}
		.swiper-footer {
			bottom: 8%;
		}
	}
`;

export const ImageGallery = styled.div`
	display: grid;
	grid-template-columns: 4fr 1fr;
	gap: 2.4rem;
	width: 100%;
	height: 100%;
	@media ${Breakpoints.mobile} {
		display: none;
	}

	img {
		cursor: pointer;
	}
`;

export const GallerySidebar = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;

	img {
		flex: 1;
	}
`;
